/**
 * 목록 밀도 도해 68×44 (디자인 정본 **B6-2 미리보기 라디오**).
 *
 * ★★ **도해다 — 스크린샷이 아니다.** 실제 목록을 축소해 「찍으면」 목록 CSS 가 바뀔 때마다
 *    그림도 함께 상하고 결국 아무도 안 고친다. 여기서는 **무엇이 보이고 무엇이 안 보이는지**만
 *    말한다 — 좁게는 줄만, 넓게는 동그라미(아바타) + 제목 줄 + 흐린 미리보기 줄.
 * ★  색을 여기 적지 않는다. 전부 `wc-prvfig__*` 클래스이고 값은 `Radio.css` 가 준다 —
 *    호출부가 색을 적기 시작하면 테마를 안 따라간다.
 * ★  `aria-hidden` 은 감싸는 `PreviewRadio` 가 붙인다. 뜻은 제목·설명이 진다.
 */

import type { MailListDensity } from '../../api/users';

export function DensityFigure({ density }: { density: MailListDensity }) {
  return (
    <svg width="68" height="44" viewBox="0 0 68 44" focusable="false">
      <rect className="wc-prvfig__frame" x="0.5" y="0.5" width="67" height="43" rx="5" />
      {density === 'NARROW' ? (
        <>
          <rect className="wc-prvfig__line" x="8" y="9" width="52" height="4" rx="2" />
          <rect className="wc-prvfig__line" x="8" y="20" width="52" height="4" rx="2" />
          <rect className="wc-prvfig__line" x="8" y="31" width="52" height="4" rx="2" />
        </>
      ) : (
        <>
          <circle className="wc-prvfig__dot" cx="14" cy="14" r="5" />
          <rect className="wc-prvfig__line" x="24" y="10" width="36" height="4" rx="2" />
          <rect className="wc-prvfig__soft" x="24" y="18" width="26" height="3" rx="1.5" />
          <circle className="wc-prvfig__dot" cx="14" cy="32" r="5" />
          <rect className="wc-prvfig__line" x="24" y="28" width="36" height="4" rx="2" />
          <rect className="wc-prvfig__soft" x="24" y="36" width="22" height="3" rx="1.5" />
        </>
      )}
    </svg>
  );
}
